import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from '../../../../../../../../components/items-table/create-column-definition-builder';
import { EditableCurrencyColumn } from './editable-currency-column';
import { ReadOnlyCurrencyColumn } from './read-only-currency-column';

import messages from '../../messages';

const totalPaidColumnId = 'edit-total-paid-column';

const TotalPaid = ({ value, updateRowProperty, row: { original } }) => {
  if (value.disabled) {
    return <ReadOnlyCurrencyColumn currencyValue={value} />;
  }
  return (
    <EditableCurrencyColumn columnId={totalPaidColumnId} currencyValue={value} original={original} updateRowProperty={updateRowProperty} />
  );
};

TotalPaid.propTypes = {
  value: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
    disabled: PropTypes.bool,
  }).isRequired,
  updateRowProperty: PropTypes.func.isRequired,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      [totalPaidColumnId]: PropTypes.shape({
        code: PropTypes.string,
        value: PropTypes.number,
        disabled: PropTypes.bool,
      }),
    }).isRequired,
  }).isRequired,
};

const totalPaidColumnDefinition = createColumnDefinitionBuilder({
  header: <FormattedMessage {...messages.totalPaid} />,
  accessor: totalPaidColumnId,
  cell: TotalPaid,
  width: 1.5,
});

export { totalPaidColumnId, totalPaidColumnDefinition };
